module.exports = __webpack_public_path__ + "img/periodic_harsh_acc.dae90fbd.png";